module.exports = __webpack_public_path__ + "static/media/AW0081-54L_01.3aef6c1c.png";